import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <section id={id} className={`py-20 md:py-32 relative ${className}`} data-id="element-567">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-568">
        {children}
      </motion.div>
    </section>;
}